<template>
  <!-- 添加或修改业务对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="open"
    width="700px"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form ref="judgesInfo" v-model="judgesInfo">
      <el-row>
        <el-form-item label="课题属性" label-width="150px" :required="true">
          <el-select
            v-model="judgesInfo.courseGroup"
            placeholder="请选择"
            clearable
            filterable
            style="width: 350px"
          >
            <el-option
              v-for="item in courseGroupList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色类型" label-width="150px" :required="true">
          <el-checkbox-group v-model="judgesTypeList">
            <el-checkbox label="1">评委</el-checkbox>
            <el-checkbox label="2">导师</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="名单" label-width="150px" :required="true">
          <treeselect
            v-model="judgesInfo.ygbh"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 200px"
            size="small"
            @select="handleSelectYg"
            @input="handleChangeYg"
          />
        </el-form-item>

        <el-form-item label="部门" label-width="150px" :required="true">
          <el-input
            v-model="judgesInfo.workUnit"
            style="width: 350px"
            disabled
          />
        </el-form-item>
        <el-form-item label="职位" label-width="150px" :required="true">
          <el-input v-model="judgesInfo.post" style="width: 350px" disabled />
        </el-form-item>
        <el-form-item label="有效开始时间" label-width="150px" :required="true">
          <el-date-picker
            style="width: 350px"
            v-model="judgesInfo.startTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="有效结束时间" label-width="150px" :required="true">
          <el-date-picker
            style="width: 350px"
            v-model="judgesInfo.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm()">确 定</el-button>
      <el-button @click="cancel()">取 消</el-button>
    </div>
  </el-dialog>
</template>
    <script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getDict } from "@/api/common";
import { judgesAdd } from "@/api/judges.js";
export default {
  name: "Add",
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  components: { Treeselect },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      // 弹出层标题
      title: "添加", // 是否显示弹出层
      open: false, // 表单参数
      judgesInfo: {},
      judgesTypeList: [],
      courseGroupList: [],
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getDict("pmp_course_group", "1").then((res) => {
      if (res.code == 0) {
        this.courseGroupList = res.data;
      }
    });
  },
  methods: {
    init() {
      this.open = true;
    },
    cancel() {
      this.open = false;
    } /** 提交按钮 */,
    submitForm() {
      if (this.judgesTypeList.length == 1) {
        this.judgesInfo.judgesType = this.judgesTypeList[0];
      }
      if (this.judgesTypeList.length == 2) {
        this.judgesInfo.judgesType = "3";
      }
      judgesAdd(this.judgesInfo).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          this.open = false;
          this.$parent.getList();
          this.judgesInfo = {};
          this.judgesTypeList = [];
        } else {
          this.$notify({
            title: "失败",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    handleSelectYg(e) {
      // this.shrList
      this.judgesInfo.post = e.gwmc;
      this.judgesInfo.judges = e.xm;
      this.deptUser.forEach((item) => {
        if (item.bmid == e.bmid) {
          this.judgesInfo.workUnit = item.bmmc;
        }
      });
    },
    handleChangeYg(e) {
      if (!e) {
        this.judgesInfo.post = null;
        this.judgesInfo.judges = null;
        this.judgesInfo.workUnit = null;
      }
    },
  },
};
</script>